<template>
    <div class="info-box-container">
        <h3>
            {{ card === "Attributes" ? title : $t(`ProductionProgress.InfoTab.${card}.${title}`) }}
        </h3>
        <div class="info-container">
            <div
                :class="{ 'ellipsis-info': data.truncate }"
                v-b-tooltip.hover="{
                    customClass: `${
                        data.truncate && windowWidth > 768 ? 'info-order-tooltip' : 'display-none'
                    }`
                }"
                :title="formattedValue"
            >
                <span>{{ formattedValue | emptyToDash }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { VBTooltip } from "bootstrap-vue";

export default {
    name: "InfoBox",
    filters: {
        emptyToDash(value) {
            if (value === null || value === undefined || value === "") {
                return "-";
            }
            return value;
        }
    },
    directives: {
        "b-tooltip": VBTooltip
    },
    props: {
        card: {
            type: String,
            default: "",
            required: true
        },
        title: {
            type: String,
            default: "",
            required: true
        },
        isDate: {
            type: Boolean,
            default: false,
            required: true
        },
        data: {
            type: Object,
            default: () => ({}),
            required: true
        }
    },
    data: () => ({
        windowWidth: window.innerWidth
    }),
    computed: {
        formattedValue() {
            if (!this.data) return "-";
            const val = this.data.value;
            if (val === null || val === undefined || val === "") return "-";

            if (this.isDate || this.title === "DueDate" || this.title === "EarlyStartDate") {
                return this.getFormatedDate(val);
            }

            if (this.title === "Quantity" || this.title === "Priority") {
                return this.formatNumberClean(val);
            }

            return this.getFormatResources(val);
        }
    },
    methods: {
        getFormatedDate(date) {
            if (!date) return "";
            const str = String(date).trim();

            if (/^\d{2}\/\d{2}\/\d{4}\s+00:00(:00)?$/.test(str)) {
                return str.split(" ")[0];
            }

            const m = moment(date, [
                moment.ISO_8601,
                "YYYY-MM-DD HH:mm:ss",
                "YYYY-MM-DD",
                "DD/MM/YYYY HH:mm:ss",
                "DD/MM/YYYY"
            ]);
            if (m.isValid()) {
                if (m.hours() === 0 && m.minutes() === 0 && m.seconds() === 0) {
                    return m.format("DD/MM/YYYY");
                }
                return m.format("DD/MM/YYYY HH:mm:ss");
            }

            return str;
        },
        formatNumberClean(val) {
            if (val === null || val === undefined || val === "") return "-";
            let str = String(val).trim();
            if (str.includes(",") || str.includes(".")) {
                str = str.replace(/([.,]0+)$/, "");
                if (str.includes(",") || str.includes(".")) {
                    str = str.replace(/0+$/, "");
                }
            }
            return str;
        },
        getFormatResources(value) {
            if (Array.isArray(value)) {
                return value.map((e) => e.name || e).join(", ");
            }

            if (value && typeof value === "object" && !Array.isArray(value)) {
                let values = [];
                if (value.singleValues && Array.isArray(value.singleValues)) {
                    values = values.concat(value.singleValues);
                }
                if (value.multipleValues && Array.isArray(value.multipleValues)) {
                    values = values.concat(value.multipleValues);
                }

                if (values.length > 0) return values.join(", ");
            }

            return value;
        }
    }
};
</script>

<style lang="scss">
.display-none {
    display: none;
}

.info-order-tooltip {
    margin: 0;
    z-index: 99999999;
    max-height: none !important;

    .tooltip-inner {
        max-width: 516px !important;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        text-align: left;
        padding: 8px 12px;
        background-color: #362f2b;
        border-radius: 6px;
        border: none;
        outline: none;
    }

    .arrow {
        &::before {
            border-top-color: #362f2b;
            border-bottom-color: #362f2b;
        }
    }
}
</style>

<style lang="scss" scoped>
.info-box-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: #fbf9f8;
    border: 1px solid #e8e2de;
    border-radius: 8px;
    padding: 10px 14px;
    min-height: 66px;
    box-sizing: border-box;
    transition: all 0.2s ease;

    &:hover {
        background: #ffffff;
        border-color: #cfc4be;
        box-shadow: 0 2px 8px rgba(151, 73, 0, 0.05);
    }

    h3 {
        font-family: "Raleway", sans-serif;
        font-weight: 600;
        font-size: 11px;
        line-height: 14px;
        color: #8c827a;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        margin: 0 0 4px 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .info-container {
        display: flex;
        align-items: center;
        overflow: hidden;
        line-height: 1.25;

        span,
        .ellipsis-info {
            font-family: "Raleway", sans-serif;
            font-weight: 700;
            font-size: 15px;
            line-height: 20px;
            color: #2b2521;
            margin: 0;
        }

        .ellipsis-info {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 100%;
        }
    }
}

@media (max-width: 600px) {
    .info-box-container {
        padding: 8px 12px;
        min-height: 60px;

        h3 {
            font-size: 10px;
        }

        .info-container {
            span,
            .ellipsis-info {
                font-size: 14px;
            }
        }
    }
}
</style>
